import { Outlet } from 'react-router-dom';
import Nav from '@/components/Nav';
import ScrollProgress from '@/components/ScrollProgress';
import SiteFooter from '@/components/SiteFooter';
import ValueField from '@/field/ValueField';
import { useReducedMotionSync } from '@/lib/a11y';
import ScrollToTop from './ScrollToTop';
import '@/field/valueField.css';
import '@/styles/chapters.css';
import '@/components/ScrollProgress.css';
import './App.css';

/** Persistent shell around every page: field background, header, footer. */
export default function Layout() {
  useReducedMotionSync();

  return (
    <>
      <ValueField />
      <Nav />
      <ScrollProgress />
      <ScrollToTop />
      <main id="main" className="page-main">
        <Outlet />
      </main>
      <SiteFooter />
    </>
  );
}
